module.exports = __webpack_public_path__ + "img/subject1_06_106.jpg";